import { Link } from "react-router-dom";
import { weeklyTop, events } from "@/mocks/content";

function deltaView(delta: string) {
  if (delta.startsWith("+")) {
    return (
      <span className="flex items-center gap-0.5 text-xs font-medium text-accent-600">
        <i className="ri-arrow-up-line"></i>
        {delta.replace("+", "")}
      </span>
    );
  }
  if (delta.startsWith("-")) {
    return (
      <span className="flex items-center gap-0.5 text-xs font-medium text-secondary-700">
        <i className="ri-arrow-down-line"></i>
        {delta.replace("-", "")}
      </span>
    );
  }
  return <span className="text-xs font-medium text-foreground-400">—</span>;
}

export default function WeeklyPreview() {
  const rows = weeklyTop.slice(0, 5).map((row) => {
    const event = events.find((e) => e.slug === row.slug);
    return { ...row, event };
  });

  return (
    <section
      className="w-full border-y border-background-200/70 bg-secondary-950 px-4 py-14 text-background-100 md:px-8 md:py-20"
      aria-labelledby="weekly-title"
    >
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-primary-300">
            Weekly Chart
          </p>
          <h2
            id="weekly-title"
            className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl"
          >
            本周瓜单 TOP 5
          </h2>
        </div>
        <Link
          to="/roundup"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-300 transition-colors hover:text-primary-200"
        >
          完整榜单
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <ol className="divide-y divide-background-50/10 border-y border-background-50/10">
        {rows.map((row) => (
          <li key={row.slug}>
            <Link
              to={`/events/${row.slug}`}
              className="group flex items-center gap-4 py-4 transition-colors hover:bg-background-50/5"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                  row.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-50/10 text-background-100"
                }`}
              >
                {row.rank}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-heading text-base font-semibold text-background-50 transition-colors group-hover:text-primary-200 md:text-lg">
                  {row.event?.title}
                </span>
                <span className="mt-1 flex flex-wrap items-center gap-3 text-xs text-background-400">
                  <span>{row.event?.category}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-400"></i>
                    热度 {row.heat.toFixed(1)}
                  </span>
                </span>
              </span>
              {deltaView(row.delta)}
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}